<div class="dialog-header">
    <span class="filter-header">{{ event.title }}</span>
    <fa-icon icon="times" class="clickable" (click)="dialogRef.close()"> </fa-icon>
</div>

<div #content class="dialog-content">
    <eaglei-recent-event-info [event]="event"></eaglei-recent-event-info>
</div>
